import { createFileRoute } from '@tanstack/react-router'

import { RdMarketingSettingsPage } from '@/features/integrations/rd-marketing-settings-page'

export const Route = createFileRoute('/_app/integracoes/rd-marketing/')({
  component: RdMarketingSettingsPage,
})
